export const processSteps = [
  {
    title: 'Kickoff-Call',
    description: 'Wir lernen dein Team, deine Produkte und deinen Vertriebsprozess kennen.',
  },
  {
    title: 'Analyse',
    description: 'Wir bekommen Zugriff auf dein System und analysieren den Ist-Zustand.',
  },
  {
    title: 'Report',
    description: 'Du erhältst einen Report mit konkreten Vorschlägen, was wir anpassen würden.',
  },
  {
    title: 'Abstimmung',
    description: 'Wir besprechen Vorschläge und Gegenvorschläge, bis alles zu dir passt.',
  },
  {
    title: 'Umsetzung & Betreuung',
    description: 'Wir setzen individuell um und entwickeln dein System proaktiv weiter.',
  },
]

export const team = [
  { count: '1', role: 'Direkter Ansprechpartner' },
  { count: '2', role: 'Spezialisten nur für Dashboards' },
  { count: '3', role: 'Spezialisten für weitere Automatisierungen' },
  { count: '4', role: 'Spezialisten für Close-Automatisierungen' },
]
